import { getMOTVehicleCheck, postMotNotifications } from 'PrivateApis';

type GetMOTCheckerProps = {
  opts?: {
    abortController?: AbortController;
  };
  setStatusCode?: (status?: number) => void;
  vrm: string;
};

type PostMOTNotificationsProp = {
  opts?: {
    abortController?: AbortController;
  };
  payload: { dpSellerId: number; vrm: string };
  setStatusCode?: (status?: number) => void;
}

const env = process.env.APPLICATION_ENVIRONMENT === 'production' ? 'prod' : 'stage';

export const getMOTChecker = ({
  opts = { abortController: undefined },
  setStatusCode,
  vrm,
}: GetMOTCheckerProps) => {
  const { abortController } = opts;

  return getMOTVehicleCheck(vrm, env, setStatusCode, abortController);
};

export const postNotifications = ({
  opts = { abortController: undefined },
  payload,
  setStatusCode,
}: PostMOTNotificationsProp) => {
  const { abortController } = opts;

  return postMotNotifications(payload, env, setStatusCode, abortController);
};
